import { createStore, applyMiddleware } from "redux";
import { persistStore } from "redux-persist";
import thunkMiddleware from "redux-thunk";

//Third party libraries to check errors & track redux state changes
import logger from "redux-logger";
import { composeWithDevTools } from "redux-devtools-extension";

//Main reducer which holds all other reducers
import rootReducer from "./root-reducer";

//Middlewares to handle action to reducer checkpoints and logging errors
const middlewares: any = [];
middlewares.push(thunkMiddleware);
middlewares.push(logger)

// Store exported with rootReducer containing all reducers and middlewares
export const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(...middlewares))
);

//Store data encrypted for storing securedly inside SessionsStorage
export const persistor = persistStore(store);
